import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useCallback, useRef } from 'react';

import ShadowSlot from 'components/ShadowSlot';

import useClickOutside from 'hooks/useClickOutside';

import placeholder from 'lib/placeholder';

import { useUser } from 'providers/UserProvider';

import ToolButton from '../ToolButton';

const Picker = dynamic(() => import('./Picker'), { ssr: false });

const EmojiPicker = ({ active = false, onClick, onAddEmoji }) => {
  const buttonRef = useRef(null);
  const shadowSlotRef = useRef(null);
  const { runCallbackIfLoggedIn } = useUser();
  const [isPickerOpen, setPickerOpen] = useClickOutside(
    shadowSlotRef,
    onClick,
    { exclude: [buttonRef] }
  );

  const onClickHandler = () => {
    runCallbackIfLoggedIn(() => {
      setPickerOpen((prevState) => !prevState);
      onClick();
    });
  };

  const onAddEmojiHandler = useCallback((data) => {
    onAddEmoji(data);
    setPickerOpen((prevState) => !prevState);
  }, []);

  return (
    <>
      <ToolButton
        ref={buttonRef}
        active={active}
        aria-label="Abrir seletor de emojis"
        iconName="mood"
        tip={placeholder('tips.emojis')}
        onClick={onClickHandler}
      />
      <ShadowSlot ref={shadowSlotRef} show={isPickerOpen}>
        {(props) => <Picker {...props} onAddEmoji={onAddEmojiHandler} />}
      </ShadowSlot>
    </>
  );
};

EmojiPicker.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onAddEmoji: PropTypes.func.isRequired,
};

export default EmojiPicker;
